export default __webpack_public_path__ + "static/media/x-button.0dab075a.png";